import { HeadingXSmall } from "@mezo-org/mezo-clay"

import { selectIsConnected, useDappSelector } from "#/redux-state"
import { getGreetingMessage } from "#/shared/utils"
import BorrowMatsBanner from "#/ui/Banner/MatsBorrowBanner"
import { HomepageExploreSection, HomepageMainSection } from "#/ui/Homepage"
import { MezoApps } from "#/ui/MezoApps"

export function HomePageHeader() {
  const isConnected = useDappSelector(selectIsConnected)
  const greetingMessage = getGreetingMessage()

  // If user is connected, we don't display any header
  if (isConnected) return null

  return <HeadingXSmall>{greetingMessage}</HeadingXSmall>
}

export default function HomePage() {
  return (
    <>
      <BorrowMatsBanner />
      <HomepageMainSection />
      <MezoApps />
      <HomepageExploreSection />
    </>
  )
}
